import React from 'react';
import { Table } from 'react-bootstrap';
import Row from './components/Row';

const AdkBannerDefaultOfferTable = ({ offers, onRemove, onUpdate }) => {
    const rows = offers.map((offer, index) => <Row key={index} offer={offer} onUpdate={onUpdate} onRemove={onRemove}/>);

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Title</th>
                    <th>Body</th>
                    <th>Icon</th>
                    <th>Image</th>
                    <th>URL</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default AdkBannerDefaultOfferTable;


// WEBPACK FOOTER //
// ./src/scenes/AdkBannerDefaultOffers/components/Table/index.js